import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'eci-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit {

    languages = [
        { code: 'zh', label: '🇨🇳 ZH' },
        { code: 'en', label: '🇺🇸 EN' }
      ];

    constructor(public translate: TranslateService) {
        translate.setDefaultLang('zh');
        translate.use('zh'); // Or use browser language detection
    }

    ngOnInit(): void {
    }

    switchLanguage(lang: string) {
        this.translate.use(lang);
        localStorage.setItem('app_lang', lang);
    }

}
